import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import MissionCard from "./components/MissionCard";
import { listMyMissions } from "../../utils/missionsApi";

export default function MyAcceptedMissions() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { items: list } = await listMyMissions("assigned");
      setItems(list || []);
    } catch (_) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div className="pmm-topbar">
        <div>
          <h1 className="pmm-h-accent">Missions acceptées</h1>
          <div className="pmm-topbar-sub">Vos missions confirmées : démarrez, photographiez, validez.</div>
        </div>
      </div>

      {loading ? <div className="pmm-spinner" />
        : items.length === 0 ? (
          <div className="pmm-empty">
            <div className="pmm-empty-icon"><CheckCircle2 size={28} /></div>
            <h3>Aucune mission acceptée</h3>
            <p>Lorsqu'un client accepte une de vos propositions, la mission apparaît ici.</p>
          </div>
        ) : (
          <div className="pmm-grid pmm-grid--2">
            {items.map((m) => (
              <MissionCard
                key={m._id}
                mission={m}
                onOpen={() => navigate(`/missions/${m._id}`)}
                showActions={true}
                onApply={undefined}
              />
            ))}
          </div>
        )}
    </div>
  );
}
